







































// Import vendors ----------------------------------------------------------------------------------
import { computed, defineComponent } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import PatientResultVideos from '@/components/patient/results/PatientResultVideos.vue';
import ChartWalkingContainerGroupBanner from '@/components/charts/walking/containers/ChartWalkingContainerGroupBanner.vue';
import ChartWalkingContainerGaitLine from '@/components/charts/walking/containers/ChartWalkingContainerGaitLine.vue';
import ChartWalkingContainerWalkProfile from '@/components/charts/walking/containers/ChartWalkingContainerWalkProfile.vue';
import ChartWalkingContainerPropulsionRatio from '@/components/charts/walking/containers/ChartWalkingContainerPropulsionRatio.vue';
import PatientResultSummary from '@/components/patient/results/PatientResultSummary.vue';
import ElementInterpretationManualBanner from '@/components/elements/ElementInterpretationManualBanner.vue';
import PatientResultsScoring from '@/components/patient/results/PatientResultsScoring.vue';
// Import utils ------------------------------------------------------------------------------------
import { useInterpretationManual } from '@/utils/interpretation-manual.utils';
import { usePatient } from '@/utils/patient.utils';
import { usePodocoreModuleService } from '@/plugins/podocore';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'PatientResultsWalkingGeneral',
  components: {
    PatientResultVideos,
    PatientResultSummary,
    ChartWalkingContainerGroupBanner,
    ChartWalkingContainerWalkProfile,
    ChartWalkingContainerGaitLine,
    ChartWalkingContainerPropulsionRatio,
    ElementInterpretationManualBanner,
    PatientResultsScoring
  },
  props: {
    analysis: {
      type: Object,
      required: true
    },
    aggregates: {
      type: Object,
      required: true
    },
    norms: {
      type: Object,
      required: true
    },
    displayMetrics: {
      type: Object,
      required: true
    }
  },
  setup(properties) {
    const { data: patient } = usePatient();
    const { dontShowManualInterpretation } = useInterpretationManual();

    const hasNeurological = computed(() => {
      const subscriptionId = properties.analysis?.subscriptionId;
      return subscriptionId === 'neurological_elderly_mobility_monitoring';
    });

    return {
      // Values
      patient,
      // Flags
      dontShowManualInterpretation,
      hasNeurological
    };
  }
});
